import { createImageUrl } from '@nrk/serum-imagecrop-utils';


export function getImageUrl(image, options) {
  var _ref = options || {},
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 120 : _ref$width,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === undefined ? '1:1' : _ref$ratio;

  switch (image.type) {
    case 'polopoly-image':
      {
        return createImageUrl({ id: image.id, width: width, ratio: ratio });
      }
    case 'url-image':
      {
        return image.url;
      }
  }
}


// WEBPACK FOOTER //
// ./node_modules/@nrk/dh-feature-components/dist/module/ChatLog/lib/image-url.js